import { render, staticRenderFns } from "./PlaceOrderBtn.vue?vue&type=template&id=046d3566&scoped=true"
import script from "./PlaceOrderBtn.vue?vue&type=script&lang=js"
export * from "./PlaceOrderBtn.vue?vue&type=script&lang=js"
import style0 from "./PlaceOrderBtn.vue?vue&type=style&index=0&id=046d3566&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "046d3566",
  null
  
)

export default component.exports